import React from "react";
import threeD from "../../assets/img/3d design view.png";
const ThreeDView = () => {
  return (
    <div
      className="max-h-[calc(100vh-8rem)] h-full mx-auto"
      style={{ aspectRatio: 2.09 }}
    >
      <img src={threeD} alt="" className="w-full h-full object-contain" />
    </div>
  );
};

export default ThreeDView;
